import { useContext } from 'react';
import { TransferringCallContext } from './TransferringCallContext';

export const useTransferringCallContext = () => {
  const context = useContext(TransferringCallContext);
  if (!context) {
    throw new Error(
      'useTransferringCallContext must be used within a TransferringCallProvider',
    );
  }
  return context;
};
